/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SetupRouteImport } from './routes/setup'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AddRouteImport } from './routes/add'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedSearchRouteImport } from './routes/_authenticated/search'
import { Route as AuthenticatedRssRouteImport } from './routes/_authenticated/rss'
import { Route as AuthenticatedInstancesRouteImport } from './routes/_authenticated/instances'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedCrossSeedRouteImport } from './routes/_authenticated/cross-seed'
import { Route as AuthenticatedBackupsRouteImport } from './routes/_authenticated/backups'
import { Route as AuthenticatedAutomationsRouteImport } from './routes/_authenticated/automations'
import { Route as AuthenticatedInstancesIndexRouteImport } from './routes/_authenticated/instances.index'
import { Route as AuthenticatedInstancesInstanceIdRouteImport } from './routes/_authenticated/instances.$instanceId'

const SetupRoute = SetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AddRoute = AddRouteImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSearchRoute = AuthenticatedSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRssRoute = AuthenticatedRssRouteImport.update({
  id: '/rss',
  path: '/rss',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedInstancesRoute = AuthenticatedInstancesRouteImport.update({
  id: '/instances',
  path: '/instances',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCrossSeedRoute = AuthenticatedCrossSeedRouteImport.update({
  id: '/cross-seed',
  path: '/cross-seed',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedBackupsRoute = AuthenticatedBackupsRouteImport.update({
  id: '/backups',
  path: '/backups',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAutomationsRoute =
  AuthenticatedAutomationsRouteImport.update({
    id: '/automations',
    path: '/automations',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInstancesIndexRoute =
  AuthenticatedInstancesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedInstancesRoute,
  } as any)
const AuthenticatedInstancesInstanceIdRoute =
  AuthenticatedInstancesInstanceIdRouteImport.update({
    id: '/$instanceId',
    path: '/$instanceId',
    getParentRoute: () => AuthenticatedInstancesRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/add': typeof AddRoute
  '/login': typeof LoginRoute
  '/setup': typeof SetupRoute
  '/automations': typeof AuthenticatedAutomationsRoute
  '/backups': typeof AuthenticatedBackupsRoute
  '/cross-seed': typeof AuthenticatedCrossSeedRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/instances': typeof AuthenticatedInstancesRouteWithChildren
  '/rss': typeof AuthenticatedRssRoute
  '/search': typeof AuthenticatedSearchRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/instances/$instanceId': typeof AuthenticatedInstancesInstanceIdRoute
  '/instances/': typeof AuthenticatedInstancesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/add': typeof AddRoute
  '/login': typeof LoginRoute
  '/setup': typeof SetupRoute
  '/automations': typeof AuthenticatedAutomationsRoute
  '/backups': typeof AuthenticatedBackupsRoute
  '/cross-seed': typeof AuthenticatedCrossSeedRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/rss': typeof AuthenticatedRssRoute
  '/search': typeof AuthenticatedSearchRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/instances/$instanceId': typeof AuthenticatedInstancesInstanceIdRoute
  '/instances': typeof AuthenticatedInstancesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/add': typeof AddRoute
  '/login': typeof LoginRoute
  '/setup': typeof SetupRoute
  '/_authenticated/automations': typeof AuthenticatedAutomationsRoute
  '/_authenticated/backups': typeof AuthenticatedBackupsRoute
  '/_authenticated/cross-seed': typeof AuthenticatedCrossSeedRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/instances': typeof AuthenticatedInstancesRouteWithChildren
  '/_authenticated/rss': typeof AuthenticatedRssRoute
  '/_authenticated/search': typeof AuthenticatedSearchRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_authenticated/instances/$instanceId': typeof AuthenticatedInstancesInstanceIdRoute
  '/_authenticated/instances/': typeof AuthenticatedInstancesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/add'
    | '/login'
    | '/setup'
    | '/automations'
    | '/backups'
    | '/cross-seed'
    | '/dashboard'
    | '/instances'
    | '/rss'
    | '/search'
    | '/settings'
    | '/instances/$instanceId'
    | '/instances/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/add'
    | '/login'
    | '/setup'
    | '/automations'
    | '/backups'
    | '/cross-seed'
    | '/dashboard'
    | '/rss'
    | '/search'
    | '/settings'
    | '/instances/$instanceId'
    | '/instances'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/add'
    | '/login'
    | '/setup'
    | '/_authenticated/automations'
    | '/_authenticated/backups'
    | '/_authenticated/cross-seed'
    | '/_authenticated/dashboard'
    | '/_authenticated/instances'
    | '/_authenticated/rss'
    | '/_authenticated/search'
    | '/_authenticated/settings'
    | '/_authenticated/instances/$instanceId'
    | '/_authenticated/instances/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  AddRoute: typeof AddRoute
  LoginRoute: typeof LoginRoute
  SetupRoute: typeof SetupRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/setup': {
      id: '/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof SetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/add': {
      id: '/add'
      path: '/add'
      fullPath: '/add'
      preLoaderRoute: typeof AddRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/search': {
      id: '/_authenticated/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AuthenticatedSearchRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/rss': {
      id: '/_authenticated/rss'
      path: '/rss'
      fullPath: '/rss'
      preLoaderRoute: typeof AuthenticatedRssRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/instances': {
      id: '/_authenticated/instances'
      path: '/instances'
      fullPath: '/instances'
      preLoaderRoute: typeof AuthenticatedInstancesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/cross-seed': {
      id: '/_authenticated/cross-seed'
      path: '/cross-seed'
      fullPath: '/cross-seed'
      preLoaderRoute: typeof AuthenticatedCrossSeedRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/backups': {
      id: '/_authenticated/backups'
      path: '/backups'
      fullPath: '/backups'
      preLoaderRoute: typeof AuthenticatedBackupsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/automations': {
      id: '/_authenticated/automations'
      path: '/automations'
      fullPath: '/automations'
      preLoaderRoute: typeof AuthenticatedAutomationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/instances/': {
      id: '/_authenticated/instances/'
      path: '/'
      fullPath: '/instances/'
      preLoaderRoute: typeof AuthenticatedInstancesIndexRouteImport
      parentRoute: typeof AuthenticatedInstancesRoute
    }
    '/_authenticated/instances/$instanceId': {
      id: '/_authenticated/instances/$instanceId'
      path: '/$instanceId'
      fullPath: '/instances/$instanceId'
      preLoaderRoute: typeof AuthenticatedInstancesInstanceIdRouteImport
      parentRoute: typeof AuthenticatedInstancesRoute
    }
  }
}

interface AuthenticatedInstancesRouteChildren {
  AuthenticatedInstancesInstanceIdRoute: typeof AuthenticatedInstancesInstanceIdRoute
  AuthenticatedInstancesIndexRoute: typeof AuthenticatedInstancesIndexRoute
}

const AuthenticatedInstancesRouteChildren: AuthenticatedInstancesRouteChildren =
  {
    AuthenticatedInstancesInstanceIdRoute:
      AuthenticatedInstancesInstanceIdRoute,
    AuthenticatedInstancesIndexRoute: AuthenticatedInstancesIndexRoute,
  }

const AuthenticatedInstancesRouteWithChildren =
  AuthenticatedInstancesRoute._addFileChildren(
    AuthenticatedInstancesRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAutomationsRoute: typeof AuthenticatedAutomationsRoute
  AuthenticatedBackupsRoute: typeof AuthenticatedBackupsRoute
  AuthenticatedCrossSeedRoute: typeof AuthenticatedCrossSeedRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedInstancesRoute: typeof AuthenticatedInstancesRouteWithChildren
  AuthenticatedRssRoute: typeof AuthenticatedRssRoute
  AuthenticatedSearchRoute: typeof AuthenticatedSearchRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAutomationsRoute: AuthenticatedAutomationsRoute,
  AuthenticatedBackupsRoute: AuthenticatedBackupsRoute,
  AuthenticatedCrossSeedRoute: AuthenticatedCrossSeedRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedInstancesRoute: AuthenticatedInstancesRouteWithChildren,
  AuthenticatedRssRoute: AuthenticatedRssRoute,
  AuthenticatedSearchRoute: AuthenticatedSearchRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AddRoute: AddRoute,
  LoginRoute: LoginRoute,
  SetupRoute: SetupRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
